var map = {
	"./Back.svg": 45592,
	"./Bank.svg": 76807,
	"./Clock.svg": 35033,
	"./Close.svg": 83871,
	"./Lock.svg": 83320,
	"./Medallion_Logo_TM_RGB.svg": 39052,
	"./Passport.svg": 5063,
	"./Quiz.svg": 10174,
	"./Shield.svg": 90394,
	"./at_arrow-left.svg": 3782,
	"./at_check-verified-02-filled.svg": 61667,
	"./at_chevron-down.svg": 98679,
	"./at_chevron-right.svg": 73591,
	"./at_pencil-02.svg": 9585,
	"./at_search-sm-filled.svg": 26887,
	"./at_verified-01.svg": 79095,
	"./at_x-close.svg": 27772,
	"./attachment-icon.svg": 30656,
	"./browsers.svg": 31262,
	"./correct-id-1.svg": 85471,
	"./correct-id-2.svg": 6444,
	"./correct-selfie-1.svg": 36400,
	"./correct-selfie-2.svg": 77091,
	"./correct_selfie_capture.svg": 59299,
	"./digital-lock-gray.svg": 16087,
	"./failure.svg": 21301,
	"./filled-check-circle.svg": 12503,
	"./hx_alert-circle.svg": 48831,
	"./icon-cross.svg": 17005,
	"./identity-gray.svg": 98649,
	"./incorrect-id-1.svg": 45110,
	"./incorrect-id-2.svg": 65397,
	"./incorrect-id-3.svg": 43764,
	"./incorrect-id-4.svg": 5115,
	"./incorrect_selfie_capture.svg": 61518,
	"./input_mail.svg": 95999,
	"./loader.svg": 42060,
	"./out-of-attempts.svg": 40530,
	"./page-not-found.svg": 25711,
	"./quick-process-gray.svg": 494,
	"./secure-shield-gray.svg": 74160,
	"./warning-fill.svg": 64351,
	"./wrong-selfie-1.svg": 97471,
	"./wrong-selfie-2.svg": 18444,
	"./wrong-selfie-3.svg": 53901,
	"./wrong-selfie-4.svg": 44610,
	"./wrong-selfie-5.svg": 75187
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;